'use client';

import { useEffect } from 'react';
import { useRouter } from '@/i18n/routing';
import { Box, Typography, Button, Container } from '@mui/material';
import { Link } from '@/i18n/routing';

export default function NotFound() {
    const router = useRouter();

    useEffect(() => {
        router.replace('/');
    }, [router]);

    return (
        <Container maxWidth="sm" sx={{ py: 12, textAlign: 'center' }}>
            <Typography variant="h1" sx={{ fontWeight: 800, color: '#132c4b', mb: 2 }}>
                404
            </Typography>
            <Typography variant="h5" sx={{ fontWeight: 600, color: '#475569', mb: 2 }}>
                Page Not Found
            </Typography>
            <Typography variant="body1" sx={{ color: '#64748b', mb: 4 }}>
                お探しのページは見つかりませんでした。
            </Typography>
            <Button
                component={Link}
                href="/"
                variant="contained"
                sx={{
                    bgcolor: '#F15859',
                    fontWeight: 700,
                    px: 4,
                    py: 1.5,
                    borderRadius: '8px',
                    '&:hover': { bgcolor: '#be123c' }
                }}
            >
                ホームに戻る
            </Button>
        </Container>
    );
}
